import React from 'react';
import PropTypes from 'prop-types';
import css from './MultiSelectField.scss'
import Icon from 'SF/MaterialIcon';

const CheckBox = ({ label, disabled, ...inputProps }) => {
  return (
    <div className={css['checkbox-wrapper']}>
      <label className={`${css['checkbox']} ${disabled ? css['disabled'] : ''}`}>
        <input
          type="checkbox"
          disabled={disabled}
          {...inputProps}
        />
        <span className={css['checkbox-label']}>{label}</span>
      </label>
    </div>
  )
}

CheckBox.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}

export default class MultiSelectField extends React.Component {

  changeHandler = (e, index) => {
    let updatedValues = [...(this.props.value || [])];
    if (this.props.options[index].value !== e.target.value) return;
    if (updatedValues.includes(e.target.value))
      updatedValues.splice(updatedValues.indexOf(e.target.value), 1)
    else {
      updatedValues.push(e.target.value)
    }
    this.props.setValue(updatedValues)
  }

  isCheckboxSelected = (value) => {
    if (!this.props.value) return false;
    return this.props.value.includes(value)
  }

  render() {
    const { options, isReadOnly, hasError, questionText } = this.props
    return (
      <>
        <div className={css['multi-select-wrapper']} role="group" aria-label={questionText}>
          {options.map((option, index) =>
            <CheckBox
              key={index}
              value={option.value}
              label={option.display}
              checked={this.isCheckboxSelected(option.value)}
              onChange={(e) => this.changeHandler(e, index)}
              name={`multi-select-${this.props.questionNumber}`}
              disabled={isReadOnly}
            />
          )}
        </div>
        {hasError && !isReadOnly && (
          <div className={css['input-error-message-block']} role="alert">
            <Icon icon="error" /><p>Invalid option selected</p>
          </div>
        )}
      </>
    )
  }
}

MultiSelectField.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  isRequired: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func,
  questionNumber: PropTypes.number,
  questionText: PropTypes.string
}
